function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 2C2 1.44772 2.44772 1 3 1H12.2C12.7523 1 13.2 1.44772 13.2 2V7.07375C12.5636 6.77148 11.8517 6.60234 11.1003 6.60234C8.3941 6.60234 6.20029 8.79615 6.20029 11.5023C6.20029 12.8722 6.76243 14.1108 7.66861 15H3C2.44771 15 2 14.5523 2 14V2ZM4.10046 4.50365C4.10046 4.11705 4.41386 3.80365 4.80046 3.80365H10.4005C10.7871 3.80365 11.1005 4.11705 11.1005 4.50365C11.1005 4.89025 10.7871 5.20365 10.4005 5.20365H4.80046C4.41386 5.20365 4.10046 4.89025 4.10046 4.50365ZM4.80034 6.59766C4.41374 6.59766 4.10034 6.91106 4.10034 7.29766C4.10034 7.68426 4.41374 7.99766 4.80034 7.99766H6.40034C6.78694 7.99766 7.10034 7.68426 7.10034 7.29766C7.10034 6.91106 6.78694 6.59766 6.40034 6.59766H4.80034ZM14.6005 11.5C14.6005 13.433 13.0335 15 11.1005 15C9.16746 15 7.60046 13.433 7.60046 11.5C7.60046 9.567 9.16746 8 11.1005 8C13.0335 8 14.6005 9.567 14.6005 11.5ZM13.6527 10.7993L11.3464 13.1056C11.1534 13.2986 10.8405 13.2986 10.6475 13.1056L9.00011 11.4583L9.69904 10.7593L10.997 12.0573L12.9538 10.1004L13.6527 10.7993Z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/stepSubmitted.f3cd59a1.svg";
export { SvgComponent as ReactComponent };